import _ from "lodash";
import React, { useRef, useEffect } from "react";
import { Modal, IconButton } from "@toddle-edu/ds-web";
import EventTitle from "../EventTitle";
import EventType from "../EventType";
import DateTime from "../DateTime";
import Description from "../Description";
import EventLocation from "../Location";
import EventParticipants from "../ParticipantsV2";
import Attachments from "../Attachments";
import Reminder from "../Reminder";
import Notification from "../Notification";
import { CancelEventButton } from "../EventActionButton";
import classes from "./FullScreenEventModalV2.scss";
import classNames from "classnames";
import { ChevronLeftOutlined, ClockTimerOutlined } from "@toddle-edu/ds-icons";
import ConformationModal from "../ConfirmationModal";
import { connect } from "react-redux";
import { resetEventModalV2 } from "MyCalendar/modules/MyCalendarModule";
import { EVENT_MODE_LABELS, Z_INDEX } from "../../modules/Utils";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import RepeatEvent from "../RepeatEvent";

const styles = {
  container: {
    maxWidth: "100%",
    maxHeight: "100%",
    inset: "unset",
    borderRadius: "unset",
  },
  headerStyle: {
    padding: "0px",
  },
  bodyStyle: {
    padding: "0px",
  },
};
const FullScreenEventModal = props => {
  const {
    t,
    isModalOpen,
    setIsModalOpen,
    closeModal,
    isConfirmationModalOpen,
    onDiscardingChanges,
    onCancelDiscardingChanges,
    isEditMode,
    mode,
    actionButtons,
    showFullScreenLoader,
    isRepeatEvent,
    operationalDays,
    testId,
  } = props;
  const contentRef = useRef(null);

  useEffect(() => {
    // setting styles for the modal content to make it full screen asyncronously to avoid contentRef.current being null ref takes time to be set
    setTimeout(() => {
      if (contentRef?.current) {
        Object.assign(contentRef.current.style, {
          maxWidth: "100%",
          maxHeight: "100%",
          inset: "unset",
          borderRadius: "unset",
          overflowY: "hidden",
        });
      }
    });
  }, [contentRef]);
  return (
    <>
      <Modal
        width="100vw"
        height="100vh"
        setIsModalOpen={setIsModalOpen}
        isOpen={isModalOpen}
        onClose={closeModal}
        style={styles.container}
        contentRef={contentRef}
        zIndex={Z_INDEX}
      >
        <Modal.Header
          isClosable={false}
          isSticky={true}
          hasSeparator={true}
          style={styles.headerStyle}
        >
          <div className={classes.container}>
            <ConformationModal
              isConfirmationModalOpen={isConfirmationModalOpen}
              t={t}
              onCancelDiscardingChanges={onCancelDiscardingChanges}
              onDiscardingChanges={onDiscardingChanges}
            />
            <div className={classes.left}>
              <IconButton
                variant="neutral"
                type="plain"
                onClick={closeModal}
                icon={<ChevronLeftOutlined variant="subtle" />}
                size="medium"
              />
              <h6 className={classNames(classes.headerHeading)}>
                {t(_.get(EVENT_MODE_LABELS, mode, "calendar:new_event"))}
              </h6>
            </div>
            <div className={classes.right}>
              <CancelEventButton onClick={closeModal} />
              {_.get(actionButtons, mode, null)}
            </div>
          </div>
        </Modal.Header>{" "}
        <Modal.Body isScrollable={true} style={styles.bodyStyle}>
          <div className={classes.modalBody}>
            <div className={classes.mainContent}>
              <div className={classes.eventDetailsCard}>
                <EventTitle
                  containerClass={classes.eventTitle}
                  isAutoFocus={!isEditMode}
                  characterCountClass={classes.characterCountClass}
                  testId={`${testId}-fullScreenEventModal`}
                />
                <div className={classes.eventType}>
                  <EventType
                    dropdownContainerClass={classes.dropdownContainerClass}
                    showBorder={true}
                  />
                </div>

                <div className={classes.eventDateTime}>
                  <DateTime
                    dateTimeContainerClass={classes.dateTimeContainerClass}
                    dateContainerClass={classes.dateContainerClass}
                    showBorder={true}
                    isClearable={true}
                    fullScreenDateContainer={classes.fullScreenDateContainer}
                    isSelectedSlotVisible={false}
                  />
                  {isRepeatEvent ? (
                    <div className={classes.repeatEvent}>
                      <RepeatEvent
                        dropdownContainerClass={classes.dropdownContainerClass}
                        showBorder={true}
                        operationalDays={operationalDays}
                        horizontalMarginClass={classes.repeatTextClass}
                        skipNonOperationalDaysClassName={
                          classes.skipNonOperationalDays
                        }
                        isFullScreenMode={true}
                      />
                    </div>
                  ) : null}
                </div>
                <div className={classes.eventLocation}>
                  <EventLocation
                    variant={"outlined"}
                    locationClass={classes.locationClass}
                    testId={testId}
                  />
                </div>
              </div>

              <EventParticipants isFullScreenMode={true} testId={testId} />

              <div className={classes.eventDescriptionCard}>
                <div className={classes.eventDescription}>
                  <Description testId={testId} />
                </div>
              </div>

              <div className={classes.eventAttachmentsCard}>
                <div className={classes.eventAttachments}>
                  <Attachments
                    isFullScreenMode={true}
                    iconButtonType="plain"
                    testId={testId}
                  />
                </div>
              </div>

              <div className={classes.eventReminderCard}>
                {!isEditMode ? (
                  <>
                    <Notification testId={testId} />
                    <div className={classes.seperator}></div>
                  </>
                ) : null}
                <Reminder
                  className={classes.reminder}
                  icon={
                    <ClockTimerOutlined size={"xx-small"} variant="subtle" />
                  }
                  reminderRowContainerClass={classes.reminderRowContainer}
                  reminderLabelClass={classes.reminderLabel}
                  addReminderButtonClass={classes.addReminderClass}
                  testId={testId}
                />
              </div>
              <div className={classes.bottomSpaceHeight} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {showFullScreenLoader ? <FullScreenLoader /> : null}
    </>
  );
};

const localMapActionCreators = {
  resetEventModalV2,
};
export default connect(null, localMapActionCreators)(FullScreenEventModal);
